import store from './../store/store';
import Mixin from './../utils/mixin';

let Login = () => import('../pages/auth/Login');
let DirectLogin = () => import('../pages/auth/DirectLogin');
let Registration = () => import('../pages/auth/Registration');
let ForgotPassword = () => import('../pages/auth/ForgotPassword');
let NewPassword = () => import('../pages/auth/NewPassword');
let VerifyAccount = () => import('../pages/auth/VerifyAccount');

export default [
    {
        path: '/user/login',
        component: Login,
        name: 'Login',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/logout',
        name: 'Logout',
        meta: { requiresAuth: true },
        beforeEnter: async (to, from, next) => {
            await Mixin.methods.call_api('post', 'auth/logout');
            store.dispatch('cart/resetCart');
            store.dispatch('wishlist/resetWishlist');
            store.dispatch('auth/logout');
            return next({ name: 'Home' });
        },
    },
    {
        path: '/user/direct_login',
        component: DirectLogin,
        name: 'DirectLogin',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/registration',
        component: Registration,
        name: 'Registration',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/forgot-password',
        component: ForgotPassword,
        name: 'ForgotPassword',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/new-password',
        component: NewPassword,
        name: 'NewPassword',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/verify-account',
        component: VerifyAccount,
        name: 'VerifyAccount',
        meta: { requiresAuth: false },
    },
];
